import React, { useEffect, useState } from "react";
import { Flex } from "@chakra-ui/react";
import { useNavigate, useParams } from "react-router-dom";
import { appRoutes } from "../../../App";
import {
  AppHeader,
  AppHeaderHeight,
} from "../../shared/views/AppHeader/AppHeader";
import { LoadingScreen } from "../../shared/views/LoadingScreen/LoadingScreen";
import { OsaWayApi } from "../services/OsaWayApi";
import { CampaignApi } from "../../project/services/CampaignApi";
import { ErrorScreen } from "../../shared/views/ErrorScreen/ErrorScreen";

export const OsaWayRedirectPage: React.FC = () => {
  const osaWayId = useParams().osaWayId!;

  const [showError, setShowError] = useState(false);
  const navigate = useNavigate();

  const loadContextAndRedirect = async () => {
    const osaWay = await OsaWayApi.get(osaWayId).then((r) => r.data);
    const campaign = await CampaignApi.get(osaWay.campaignId).then(
      (r) => r.data
    );

    const urlParams = new URLSearchParams();
    urlParams.append("osaWayId", osaWay.id);
    urlParams.append("campaignId", campaign.id);

    navigate(
      `${appRoutes.project(campaign.projectId)}?${urlParams.toString()}`
    );
  };

  useEffect(() => {
    loadContextAndRedirect().catch(() => {
      setShowError(true);
    });
    // eslint-disable-next-line
  }, []);

  return (
    <Flex flexDir="column" maxHeight="100vh" flexGrow={1} position="relative">
      <AppHeader />
      <AppHeaderHeight />

      {showError ? <ErrorScreen errorCode={404} /> : <LoadingScreen />}
    </Flex>
  );
};
